import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Inscription from 'app/core/models/inscription';
import { InscriptionService } from 'app/service/inscription.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/service/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-inscription-scan',
  templateUrl: './inscription-scan.component.html',
  styleUrls: ['./inscription-scan.component.css']
})
export class InscriptionScanComponent implements OnInit {

  public inscriptions: Array<Inscription>;
  public qrScan: string;
  public inscription: any;
  public existScan = false;
  public dataPieChart: any[] = [
    {
      name: "Scanné",
      value: 0
    },
    {
      name: "Non scanné",
      value: 0
    }
  ];

  public viewPieChart: any[] = [700, 300];
  public gradient: boolean = true;
  public colorSchemePieChart = { domain: ['#5AA454', '#A10A28', '#a96921'] };
  public isDataLoaded = false;

  // A valider avant la mise en prod
  public isCheckedCanceled = false;

  constructor(
    private toastr: ToastrService,
    private inscriptionService: InscriptionService,
    private modalService: NgbModal,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
  ) { }

  async ngOnInit() {
    await this.refreshData();
  } // fin ngOnInit

  async refreshData() {
    this.isDataLoaded = false;

    const data = {
      isCheckedCanceled: this.isCheckedCanceled
    }
    const inscriptions:any = await this.inscriptionService.getInscriptions(data).toPromise();
    this.inscriptions = inscriptions;
    const inscriptionsScanned = await this.inscriptionService.getInscriptionsScanned().toPromise();
    this.dataPieChart[0].value = inscriptionsScanned.length;
    this.dataPieChart[1].value = this.inscriptions.length - inscriptionsScanned.length;
    this.isDataLoaded = true;
  }

  async changeQrScan() {
    const dataFilter = {
      _id: this.qrScan
    };

    console.log(dataFilter);

    const scanTicket = await this.inscriptionService.getInscription(this.qrScan).toPromise();
    if (scanTicket !== null) { // il existe bien une inscription associée à ce QrCode
      this.existScan = true;
      this.inscription = scanTicket;
      this.qrScan = '';
      if (this.inscription.isScan === true) { // déjà scannée
        this.toastr.warning('Invitation déjà scannée');
      } else { // qrcode valide reste à mettre scan à true
        this.inscriptionService.scanInscription(dataFilter).subscribe((response: any) => {
          if (response === 'Successfully scanned') {
            this.toastr.success('Inscription scannée avec succès');
            this.refreshData();
          } else {
            this.toastr.warning('Le serveur a rencontré un problème');
          }
        }); // fin http scanInscription
      }
    } else {
      this.existScan = false;
      this.qrScan = '';
      this.toastr.warning('Aucune invitation associée à ce QrCode');
    }
  } // fin changeQrScan

}
